<template>
  <div>
    <common-list
      ref="list"
      url="VehicleRegistration/GetList"
      :init="filter"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <!-- <el-col :span="6">
          <el-form-item label="入场编号">
            <el-input
              v-model="filter.RegistrationNum"
              placeholder="入场编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input
              v-model="filter.LicensePlate"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="filter.begin"
              type="date"
              placeholder="开始日期"
              @input="
                (time) => {
                  Time.begin = time;
                }
              "
              :picker-options="start_date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="filter.end"
              type="date"
              placeholder="结束日期"
              @input="
                (time) => {
                  Time.end = time;
                }
              "
              :picker-options="end_date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆VIN">
            <el-input
              v-model="filter.VinSix"
              placeholder="VIN后六位"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆状态">
            <el-select v-model="filter.InfoState" clearable>
              <el-option value="1" label="已收车"></el-option>
              <el-option value="2" label="已查验"></el-option>
              <el-option value="3" label="未办结"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:option>
        <el-button type="primary" icon="el-icon-plus" @click="add"
          >车辆登记</el-button
        >
        <el-button type="warning" icon="el-icon-edit" @click="edit"
          >完善车辆信息</el-button
        >
        <el-button type="warning" icon="el-icon-edit" @click="show"
          >查看</el-button
        >
        <el-button type="danger" icon="el-icon-delete" @click="deleteItem"
          >删除</el-button
        >
        <!-- <el-button type="warning" icon="el-icon-edit" @click="ShowMissingParts"
          >查看缺失部件</el-button
        > -->
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="ShowSettlementParts"
          >车辆结算</el-button
        >
        <print @onClickPrint="onClickPrint" :options="printoptions"></print>
      </template>

      <template v-slot:body>
        <el-table-column
          label="车辆编号"
          prop="KeyId"
          width="240"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="入场编号"
          prop="RegistrationNum"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope"
            >{{
              scope.row.RegistrationNum == 0
                ? "未编号"
                : scope.row.RegistrationNum
            }}
          </template></el-table-column
        >
        <el-table-column
          label="号牌号码"
          prop="LicensePlate"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column label="VIN后6位" prop="VinSix" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.VinSix | gang }}</template>
        </el-table-column>
        <el-table-column label="车辆图片" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <!-- <i
              class="el-icon-picture-outline"
              style="cursor: pointer"
              @click="showImg(row.VehiclePhoto)"
            ></i>  -->
            <!-- <el-image
              style="width: 30px; height: 30px"
              :src="row.VehiclePhoto"
              @click="showImg(row.VehiclePhoto)"
              :preview-src-list="srcList"
            >
            </el-image>  -->
            <el-image
              style="width: 130px; height: 130px"
              :src="row.VehiclePhotoUrl"
              :preview-src-list="[row.VehiclePhotoUrl]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image> </template
        ></el-table-column>
        <el-table-column
          label="车主姓名"
          prop="OwnerName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="ContactNumber"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column label="收车时间" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.OperationDate | datetime("YYYY-MM-DD") }}
          </template></el-table-column
        >

        <el-table-column label="车辆状态" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.InfoState | enumer("register_queue_state") }}
          </template></el-table-column
        >
      </template>
    </common-list>
    <div>
      <ShowMissingPartsDialog
        :item="itemMissingPartsShow"
      ></ShowMissingPartsDialog>
      <ShowSettlementDialog
        :item="itemSettlementShow"
        @success="getData"
      ></ShowSettlementDialog>
    </div>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";
import ShowMissingPartsDialog from "./ShowMissingParts";
import ShowSettlementDialog from "./Settlement";
export default {
  components: {
    ShowMissingPartsDialog,
    ShowSettlementDialog,
  },
  computed: {},
  data() {
    let today = this.$dayjs().format("YYYY-MM-DD");
    return {
      itemMissingPartsShow: {},
      itemSettlementShow: {},
      filter: {
        begin: today,
        end: today,
      },
      Time: {
        begin: today,
        end: today,
      },
      start_date: {
        //开始时间范围限定
        disabledDate: (time) => {
          if (this.Time.end) {
            return (
              time.getTime() > Date.now() || time.getTime() > this.Time.end
            );
          }
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", today);
            },
          },
        ],
      },
      end_date: {
        //结束时间范围限定
        disabledDate: (time) => {
          return (
            time.getTime() >= Date.now() ||
            time.getTime() <= this.Time.begin - 8.64e7
          );
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", today);
            },
          },
        ],
      },
      srcList: [],
      printoptions: {}, //打印参数
    };
  },
  watch: {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    showImg(path) {
      this.srcList.push(path);
      // if (path) {
      //   let images =path;
      //   viewerApi({
      //     images: images,
      //   });
      // } else {
      //   this.$message.error("未上传");
      // }
    },

    add() {
      // if (!this.hasCurrentRow()) {
      //   return;
      // }
      // if (this.currentrow.InfoState != "0") {
      //   this.$message.error("只能登记未登记的车辆");
      //   return;
      // }KeyId: this.currentrow.KeyId,
      this.$router.push({
        name: "VehicleRegistAddEdit/:KeyId/:IsEdit",
        params: {
          KeyId: "1",
          IsEdit: false,
        },
      });
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }

      if (this.currentrow.InfoState == "1") {
        this.$message.error("已收车状态不能完善车辆信息");
        return;
      }
      this.$router.push({
        name: "VehicleRegistAddEdit/:KeyId/:IsEdit",
        params: {
          KeyId: this.currentrow.KeyId,
          IsEdit: true,
        },
      });
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$router.push({
        name: "VehicleRegistShow/:KeyId/:IsEdit",
        params: {
          KeyId: this.currentrow.KeyId,
          IsEdit: true,
        },
      });
    },
    ShowMissingParts() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemMissingPartsShow = {
        KeyId: this.currentrow.KeyId,
      };
    },
    ShowSettlementParts() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemSettlementShow = {
        KeyId: this.currentrow.KeyId,
      };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      if (this.currentrow.InfoState != "1") {
        this.$message.error("只能删除车辆状态为已收车的车辆");
        return;
      }
      this.$confirm(
        `将删除登记编号为【${this.currentrow.KeyId}】的数据, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("VehicleRegistration/DeleteVehicleRegistration", {
            KeyId: this.currentrow.KeyId,
          }).then(() => {
            this.$message.success("删除成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    onClickPrint(type, callback) {
      if (!this.hasCurrentRow()) {
        return;
      }
      var id = this.currentrow.KeyId;
      if (id == null || id.length == 0) {
        this.$message.error("未获取选中的列表");
        return;
      }
      this.printoptions = { id: id };
      callback(this.printoptions); //callback 执行打印 false不执行
    },
  },
};
</script>

<style></style>